module.exports = __webpack_public_path__ + "static/Boat-Final-22f6d814a0c054a92841681eccf20f62.mp4";